import { IUserDataModel, UnknownUser } from '../../data-models/user.data-model';
import { IInitializedFormatter } from './IInitializedFormatter';

export class UserFormatter implements IInitializedFormatter<Map<number, IUserDataModel>, number | number[]> {
  #usersById: Map<number, IUserDataModel> = new Map();
  #usersByEmail: Map<string, IUserDataModel> = new Map();

  init(usersById: Map<number, IUserDataModel>) {
    this.#usersById = usersById;
    this.#usersByEmail = [...usersById.values()].reduce((map, user) => {
      map.set(user.email, user);
      return map;
    }, new Map<string, IUserDataModel>());
    return this;
  }

  format = (value: number | null | (number | null)[]) => {
    if (Array.isArray(value)) {
      return value.map(this.#format).join(', ');
    }
    return this.#format(value);
  };

  #format = (value: number | null) => {
    return this.#usersById.get(value ?? -1)?.name ?? UnknownUser.name;
  };

  formatByEmail = (value: string | null | (string | null)[]) => {
    if (Array.isArray(value)) {
      return value.map(this.#formatByEmail).join(', ');
    }
    return this.#formatByEmail(value);
  };

  #formatByEmail = (value: string | null) => {
    const user = this.#usersByEmail.get(value ?? '');
    if (user) {
      return user.name;
    }
    // return the email if it doesn't match any user
    if (value) {
      return value;
    }
    return UnknownUser.name;
  };
}
